<template>
  <div class="content-section">
    <!-- Form Section -->
    <div class="form-section">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="small"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_originOrderNo') || '源头订单号'"
              prop="originOrderNo"
            >
              <el-input
                v-model="formData.originOrderNo"
                clearable
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_scmName') || '供方'"
              prop="scmCode"
            >
              <dict-select
                v-model="formData.scmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.scmName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_purchaserEntityCode') || '需方'"
              prop="purchaserEntityCode"
            >
              <dict-select
                v-model="formData.purchaserEntityCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'orderSource' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_signPlace') || '签订地点'"
              prop="signPlace"
            >
              <el-input
                v-model="formData.signPlace"
                clearable
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalAmount') || '采购金额'"
              prop="totalAmount"
            >
              <el-input
                v-model="formData.totalAmount"
                controls-position="right"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_buyerName') || '采购人员'"
              prop="buyerCode"
            >
              <dict-select
                v-model="formData.buyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.buyerName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_purchaseDate') || '制单日期'"
              prop="purchaseDate"
            >
              <el-date-picker
                v-model="formData.purchaseDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_reviewByName') || '审核人员'"
              prop="reviewBy"
            >
              <dict-select
                v-model="formData.reviewBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.reviewByName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_reviewTime') || '审核日期'"
              prop="reviewTime"
            >
              <el-date-picker
                v-model="formData.reviewTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_remark') || '备注说明'"
              prop="remark"
            >
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="3"
                clearable
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- Product Detail Table -->
    <detail-table
      ref="detailTable"
      :purchaseMaterialCode="purchaseMaterialCode"
      v-if="purchaseMaterialCode"
    />

    <choose-order-dialog
      :visible.sync="chooseOrderDialogVisible"
      :title="'选择订单'"
      type="radio"
      @confirm="onChooseOrderConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderDialog from '@/views/factory/components/choose-order'
import DetailTable from '../detail-table/index.vue'
import { add } from '@/libs/util.number.js'

export default {
  mixins: [EditLoading],
  components: {
    ChooseOrderDialog,
    DetailTable,
  },
  props: {
    purchaseMaterialCode: String,
    disabled: Boolean,
    pageType: String,
  },
  data() {
    return {
      chooseOrderDialogVisible: false,
      formData: { orderNo: '' },
      rules: {
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    totalAmount() {
      // Note: original code used formData.surcharge and materialAmount.
      // fabricPurchase uses just totalAmount.
      // I will assume materialAmount + surcharge calculation is still needed for display
      // But maybe not editable here? I exposed totalAmount as readonly.
      return add(this.formData.surcharge, this.formData.materialAmount)
    },
  },
  methods: {
    getData() {
      if (!this.purchaseMaterialCode) {
         // Emit loaded even if new
        this.$emit('loaded', this.formData)
        return
      }
      this.loadingOpen()
      this.$api
        .purchaseMaterialDetailApi({
          purchaseMaterialCode: this.purchaseMaterialCode,
        })
        .then((res) => {
          this.loadingClose()
          this.formData = res.body || {}
          this.$emit('loaded', this.formData)
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result)
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )

      this.loadingOpen()
      let saveApi = {}
      this.formData.totalAmount = this.totalAmount
      if (this.purchaseMaterialCode) {
        saveApi = this.$api.purchaseMaterialEditApi(this.formData)
      } else {
        saveApi = this.$api.purchaseMaterialAddApi(this.formData)
      }
      saveApi
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.purchaseMaterialCode) {
            this.$router.push({
              name: 'purchase-materialPurchase',
            })
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    onChooseOrderConfirm(params) {
      this.formData.orderCode = params.orderCode
      this.formData.orderNo = params.orderNo
      this.formData.custOrderNo = params.custOrderNo
      this.formData.custName = params.custName
      this.formData.endCustName = params.endCustName
      this.formData.salesPersonName = params.salesPersonName
      this.formData.v_orderType = params.v_orderType
      this.formData.v_orderExecuteType = params.v_orderExecuteType
      this.formData.v_orderSource = params.v_orderSource
      // Note: params.scmName is Execution Factory
      // But we need to be careful not to overwrite scmCode if it's different?
      // In original code:
      // this.formData.scmName = params.scmName
      this.formData.purchaserEntityCode = params.orderSource
    },
    reloadTable() {
      if (this.$refs.detailTable) {
        this.$refs.detailTable.getData()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content-section {
  background: #fff;
  padding: 18px;
}

.form-section {
  margin-bottom: 10px;
}
</style>
